import { useMemo, useEffect } from 'react';
import { Link, useLocation, Navigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import Logo from 'assets/icons/finefinders-logo.svg';
import { useSelector } from 'react-redux';
import { userStateSelector } from '../../store/selectors';
import { PAGE_PATHS } from '../../constants';
import { useTranslation } from 'react-i18next';
import { useReduxActions } from 'hooks/useReduxActions';

function useQuery() {
  const { search } = useLocation();
  return useMemo(() => new URLSearchParams(search), [search]);
}

function VerifyUser() {
  const userState = useSelector(userStateSelector);
  const query = useQuery();
  const actions = useReduxActions();
  const { t } = useTranslation();

  const verifyToken = token => {
    console.log('token', token);
    actions.verifyUser({ token });
  };

  useEffect(() => {
    if (userState.isVerifyLoading) {
      toast.loading(t('verify.user.toast.loading.message'));
    }
    if (userState.error) {
      toast.dismiss();
      toast.error(userState.error.message);
    }
    if (userState.isLoggedIn) {
      toast.dismiss();
      toast.success(t('verify.user.toast.success.message'));
    }
  }, [userState]); // eslint-disable-line

  useEffect(() => {
    if (userState.isLoggedIn || !query.get('token')) {
      return;
    }
    verifyToken(query.get('token'));
  }, [userState]); // eslint-disable-line

  if (userState.isLoggedIn || !query.get('token')) {
    return <Navigate to={PAGE_PATHS.ROOT} />;
  }

  return (
    <div className="login">
      <div className="side" />
      <div className="container">
        <div className="content-container mb">
          <img alt="Logo" src={Logo} />
          <p className="title">{t('verify.user.title')}</p>
          <p>
            {t('verify.user.hint')}{' '}
            <Link to={PAGE_PATHS.ROOT}>{t('verify.user.link.name')}</Link>
          </p>
        </div>
      </div>
    </div>
  );
}

export default VerifyUser;
